/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Kind_DescInputs */



/**
* | output |
* | --- |
* | "Which meetings this type is for. This cannot be changed later." |
*
* @param {Settings_Template_Kind_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_kind_desc = /** @type {((inputs?: Settings_Template_Kind_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Kind_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Voor welke gesprekken dit type dient. Dat kan je achteraf niet meer wijzigen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les réunions auxquelles ce modèle est destiné. Vous ne pourrez plus modifier ce choix par la suite.")
	return /** @type {LocalizedString} */ ("Which meetings this type is for. This cannot be changed later.")
});